ScreenDetection.DIRECTIVE_NAME = 'ktScreenDetection';
export default function ScreenDetection() {
    return {
        restrict: 'A',
        controller: ScreenDetectionController,
        link: ($scope, $elem, $attrs, $ctrl) => {
            $ctrl.$onInit();
        },
    };
}

export function ScreenDetectionController(
    $window,
    $rootScope,
    $timeout,
    screenDetectionService,
) {
    'ngInject';
    const vm = this;

    const EVENT_RESIZE = 'resize';
    const WIDTH_MAX_MOBILE = 768;
    const mobileTogglers = {};
    const desktopTogglers = {};

    Object.assign(vm, {
        $onInit,
        onResize,
        registerOnMobile,
        registerOnDesktop,
    });


    function $onInit() {
        vm.window = angular.element($window);
        vm.window.on(EVENT_RESIZE, _.debounce(vm.onResize, 500));
        vm.onResize();
    }

    function onResize() {
        const width = vm.window.width();
        const isMobile = width <= WIDTH_MAX_MOBILE;
        const changed = vm.isMobile !== isMobile;
        vm.isMobile = isMobile;
        screenDetectionService.setIsMobile(isMobile);

        if (changed) {
            if (vm.isMobile) {
                processDesktop();
                processMobile();
            } else {
                processMobile();
                processDesktop();
            }

            $timeout(() => $rootScope.$digest());
        }

        function processDesktop() {
            Object.values(desktopTogglers).reverse()
                .forEach((scope) => scope.forEach((toggler) => toggler(!vm.isMobile)));
        }
        function processMobile() {
            Object.values(mobileTogglers).reverse()
                .forEach((scope) => scope.forEach((toggler) => toggler(vm.isMobile)));
        }
    }

    function registerOnMobile($scope, $element, $transclude) {
        register($scope, $element, $transclude, vm.isMobile, mobileTogglers);
    }

    function registerOnDesktop($scope, $element, $transclude) {
        register($scope, $element, $transclude, !vm.isMobile, desktopTogglers);
    }

    function register($scope, $element, $transclude, initValue, togglers) {
        let block;
        let childScope;
        let previousElements;
        const toggler = (toShow) => {
            if (toShow) {
                if (!childScope) {
                    $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ');
                        block = {clone};
                        $element.after(clone);
                    });
                }
            } else {
                if (previousElements) {
                    previousElements.remove();
                    previousElements = null;
                }
                if (childScope) {
                    childScope.$destroy();
                    childScope = null;
                }
                if (block) {
                    previousElements = getBlockNodes(block.clone);
                    previousElements.remove();
                    block = null;
                }
            }
        };
        $scope.$on('$destroy', () => {
            if (mobileTogglers[$scope.$id]) {
                delete mobileTogglers[$scope.$id];
            }
            if (desktopTogglers[$scope.$id]) {
                delete desktopTogglers[$scope.$id];
            }
        });
        if (!togglers[$scope.$id]) {
            togglers[$scope.$id] = [];
        }
        togglers[$scope.$id].push(toggler);
        toggler(initValue);
    }

    function getBlockNodes(nodes) {
        let [node] = nodes;
        const endNode = nodes[nodes.length - 1];
        const blockNodes = [node];

        do {
            node = node.nextSibling;
            if (!node) {
                break;
            }
            blockNodes.push(node);
        } while (node !== endNode);

        return angular.element(blockNodes);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/screen-detection/screen-detection-directive.js